import tempMeeApi from '../../../apis/tempMee';

// What one member submitted in one cycle (awards-service GOTU-7230). Three
// different 404s are kept apart by the service — unknown cycle, no membership,
// no application — so the status alone is not enough to classify a failure
// here; deciding what a 404 means is the service layer's job.
export const getMemberApplication = async (cycleId, userId) => {
  const response = await tempMeeApi.get(
    `/awards-service-api/admin/cycles/${cycleId}/memberships/${userId}/application`,
  );

  return response.data;
};
